module.exports = __webpack_public_path__ + "img/new-logo-ATOS-g .53b3f8d6.png";